import type { Configuration } from '@azure/msal-browser';

/**
 * Entra ID configuration (spec §6.3, §9.1).
 *
 * `VITE_DEV_BYPASS=true` skips MSAL entirely: the API accepts `X-Dev-Bypass` when it runs with
 * `ENV=development`, which is how the app is developed without a tenant. Everything else reads
 * from the shared root `.env`.
 */

export const devBypassEnabled = import.meta.env.VITE_DEV_BYPASS === 'true';

export const apiBaseUrl = import.meta.env.VITE_API_BASE_URL ?? 'http://localhost:3001/v1';

const tenantId = import.meta.env.VITE_AZURE_TENANT_ID ?? '';
const clientId = import.meta.env.VITE_AZURE_CLIENT_ID ?? '';

/** The API's own scope; a token for Graph or for the SPA itself would be rejected by the backend. */
export const apiScope = import.meta.env.VITE_API_SCOPE ?? 'api://greco-gls/access_as_user';

export const msalConfigured = Boolean(tenantId && clientId);

export const msalConfig: Configuration = {
  auth: {
    clientId,
    authority: `https://login.microsoftonline.com/${tenantId}`,
    redirectUri: window.location.origin,
    postLogoutRedirectUri: window.location.origin,
  },
  cache: {
    // sessionStorage, not localStorage: a shared workstation should not keep the token around.
    cacheLocation: 'sessionStorage',
  },
};

export const loginRequest = { scopes: [apiScope] };
